import { useHouseholdChatContext } from '@/modules/household/chat/contexts/householdChat.context';

import { useDiagramEditorContext } from '../contexts/diagramEditor.context';

export type DiagramEditorLock = 'saving' | 'generating';

/**
 * Returns why the user cannot edit the diagram now, or null when they can.
 *
 * A chat reply can change the diagram. The backend links its generation
 * tracker to the artifact only after the agent starts the change, so the lock
 * also covers the chat reply. Otherwise, an edit made before the tracker
 * appears is replaced by the generated diagram.
 */
export function useDiagramEditorLock(): DiagramEditorLock | null {
  const { isGenerating, isSaving } = useDiagramEditorContext();
  const { awaitingFirstToken, streamingMessageId } = useHouseholdChatContext();
  if (isSaving) return 'saving';
  if (isGenerating || awaitingFirstToken || streamingMessageId !== null) {
    return 'generating';
  }
  return null;
}
